import styled from 'styled-components'

export const NavigationContainer = styled.nav`
	position: sticky;
	top: 0;
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem 1.5rem;
	background: rgba(250, 247, 242, 0.85);
	backdrop-filter: blur(18px);
	-webkit-backdrop-filter: blur(18px);
	border-bottom: 1px solid rgba(44, 31, 20, 0.1);
	box-shadow: 0 18px 40px rgba(44, 31, 20, 0.07);
	opacity: 0;
	transform: translateY(-18px);
	transition: opacity 220ms ease, transform 220ms ease, background-color 220ms ease,
		box-shadow 220ms ease;

	&.visible {
		opacity: 1;
		transform: translateY(0);
	}

	&.scrolled {
		background: rgba(250, 247, 242, 0.97);
		box-shadow: 0 20px 46px rgba(44, 31, 20, 0.1);
	}

	a {
		flex-shrink: 0;
	}

	img {
		border-radius: 12px;
		box-shadow: 0 10px 24px rgba(181, 98, 74, 0.18);
	}

	@media (max-width: 720px) {
		flex-direction: column;
		padding: 0.9rem 1rem 1rem;
	}
`

export const TabStyles = styled.div`
	--tab-text: #6B5444;
	--tab-text-active: #FAF7F2;
	--tab-indicator: linear-gradient(135deg, #B5624A 0%, #C87B5E 100%);
	--tab-outline: rgba(181, 98, 74, 0.25);
	width: 100%;
	display: flex;
	justify-content: flex-end;

	.tab-container {
		position: relative;
		display: inline-flex;
		align-items: center;
		gap: 0.35rem;
		padding: 0.35rem;
		border: 1px solid var(--tab-outline);
		border-radius: 999px;
		background:
			radial-gradient(circle at top, rgba(181, 98, 74, 0.12), transparent 55%),
			rgba(250, 247, 242, 0.9);
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
		overflow-x: auto;
		scrollbar-width: none;
	}

	.tab-container::-webkit-scrollbar {
		display: none;
	}

	.indicator {
		position: absolute;
		top: 0.35rem;
		left: 0;
		bottom: 0.35rem;
		width: 86px;
		border-radius: 999px;
		background: var(--tab-indicator);
		box-shadow: 0 12px 24px rgba(181, 98, 74, 0.25);
		transition: transform 240ms ease, width 240ms ease;
		pointer-events: none;
	}

	.tab-button {
		position: relative;
		z-index: 1;
		border: 0;
		background: transparent;
		color: var(--tab-text);
		padding: 0.85rem 1.15rem;
		border-radius: 999px;
		font: inherit;
		font-size: 0.95rem;
		font-weight: 600;
		letter-spacing: 0.01em;
		cursor: pointer;
		transition: color 200ms ease, transform 200ms ease;
		white-space: nowrap;
	}

	.tab-button:hover {
		transform: translateY(-1px);
	}

	.tab-button.active {
		color: var(--tab-text-active);
	}

	.tab-button:focus-visible {
		outline: 2px solid rgba(255, 255, 255, 0.9);
		outline-offset: 2px;
	}

	@media (max-width: 720px) {
		justify-content: center;
		width: 100%;

		.tab-container {
			width: 100%;
			justify-content: flex-start;
		}
	}
`

export const MenuLinks = styled.ul``

export const MenuLinksItem = styled.li``

export const Logo = styled.div``
